import React from 'react';
import getRoutes from './routes';
import styles from './app.scss';

const App = () => (
  <div className={styles.App}>
    {getRoutes()}
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/app.js